// middleware/auth-subscription.js
import { defineNuxtRouteMiddleware, navigateTo } from "#imports";
import { getUserFromSession } from "~/server/utils/authSession";
import { getConnection } from "~/server/utils/db.config";

export default defineNuxtRouteMiddleware(async (to) => {
  // Vérifier si la route nécessite un abonnement
  if (!to.meta.requiresSubscription) return;

  // 1) Vérifier l’authentification
  const session = await getUserFromSession(to);
  if (!session?.user_id) {
    return navigateTo({ path: "/login", query: { redirect: to.fullPath } });
  }

  // 2) Vérifier l’abonnement actif
  const connection = await getConnection();
  try {
    const [rows] = await connection.execute(
      `SELECT 1 FROM subscriptions
       WHERE user_id = ?
         AND status = 'active'
         AND current_period_end > NOW()
       LIMIT 1`,
      [session.user_id]
    );
    if (!rows.length) {
      return navigateTo("/user/subscribe");
    }
  } catch (err) {
    console.error("Error in middleware/auth-subscription.js:", err);
    return navigateTo("/user/subscribe");
  } finally {
    await connection.release();
  }
});
